















































import BtnDefault from '@/components/UI/BtnDefault.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';
import DialogFooter from '@/components/UI/DialogFooter.vue';
import {namespace} from 'vuex-class';
import Search from "@/components/UI/Search.vue";
import ICheckbox from '@/components/icons/ICheckbox.vue'

const dialog = namespace('dialog')
const forms = namespace('forms')
const surveys = namespace('surveys')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
    Search,
    'i-checkbox': ICheckbox,
  },
  name: "ChangeIncludeQuestionForm"
})
export default class ChangeIncludeQuestionForm extends Vue {

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @forms.Getter('options') protected options:any
  @surveys.Getter('survey') protected survey:any
  
  search:string = ''
  selectQuestions:any = []

  @Watch('fullDialogShow')
  setSelectQuestions() {
    if(this.fullDialogShow) {
      this.selectQuestions = []
      this.options.answer.includeQuestions.forEach((includeQuestion:any) => {
        this.selectQuestions.push(includeQuestion)
      })
    }
  }

  get searchQuestions() {
    return this.options.questions.filter((question:any) => {
      return question.text.toLowerCase().includes(this.search.toLowerCase().trim()) && question.id != this.options.currentQuestion.id && question.type != 'text_container' && this.getNotIncludesQuestions(this.options.currentQuestion, question.id)
    })
  }

  getNotIncludesQuestions(currentQuestion:any, id:string) {
    let flag = true
    currentQuestion.answers.forEach((answer:any) => {
      answer.includeQuestions.forEach((includeQuestion:any) => {
        if(includeQuestion.id == id) flag = false
      })
    })
    return flag
  }

  changeSelect(question:any) {
    if(this.selectQuestions.indexOf(question.id) != -1 ) {
      this.selectQuestions = this.selectQuestions.filter((q:any) => q != question.id)
    } else {
      this.selectQuestions.push(question.id)
    }
  }

  save() {
    this.options.answer.includeQuestions = this.selectQuestions
    this.SetFullDialogShow(false)
  }
  

}
